<template>
    <div>
       <img :src="model.image" :alt="model.imageAlt" :title="model.imageTitle" />
    </div>
</template>

<script>
export default {
    props: ['model'],

};
</script>
